import { dist } from '@hyakki/core';
import type { VBoard } from '../battle/adapter';

export const FIRST_BATTLE_HINTS = ['battle.territory', 'battle.relay', 'battle.relay-captured', 'battle.heal', 'battle.surge'] as const;
type HintId = typeof FIRST_BATTLE_HINTS[number];
export interface FirstBattleHint {
  id: HintId;
  text: string;
  target?: string | (() => DOMRect | null);
  cell?: number;
}

/** 自由に選んだ行動に応じて補足する。案内のために移動や回復を強制しない。 */
export function firstBattleHint(board: VBoard, moved: boolean, known: (id: string) => boolean): FirstBattleHint | null {
  const hero = board.units.find(u => u.kind === 'hero' && u.side === 'blue' && u.alive && u.cell != null);
  if (!hero || board.dashing) return null;
  const unseen = (id: HintId) => !known(id);
  if (unseen('battle.heal') && hero.hp <= hero.max * 0.65 && board.items.some(it => it.id === 'heal' && it.count > 0 && !it.block)) {
    return { id: 'battle.heal', target: visibleRect('.actions [data-act="itemmenu"]'), text: '傷が深くなっています。「道具」の回復薬でHPを戻せます。薬を使っても手番は終わらないので、そのあとに攻撃できます。使うかどうかは、あなたが決めてください。' };
  }
  if (unseen('battle.territory') && moved) {
    return { id: 'battle.territory', target: '[data-act="terrinfo"]', text: '歩いたマスが青い陣地になりました。上のゲージは、味方と敵の陣地の広さです。広げるほど、本陣への攻撃などが有利になります。ゲージを押すと、今の効果を確認できます。' };
  }
  if (unseen('battle.surge') && (board.surge?.blue?.points ?? 0) > 0) {
    return { id: 'battle.surge', target: visibleRect('[data-act="surgeinfo"]'), text: '敵を倒すと妖力が溜まります。段階が上がるたびに強くなります。メダリオンを押すと、今の効果と次の段階を確認できます。' };
  }
  const owned = board.tiles.findIndex(t => t.relay && t.owner === 'blue');
  if (unseen('battle.relay-captured') && owned >= 0) {
    return { id: 'battle.relay-captured', cell: owned, text: '龍脈を取りました。持っている間は陣地率に加算され、毎手番に受け取る陣材も増えます。敵に奪い返されないようにしましょう。' };
  }
  if (unseen('battle.relay') && owned < 0) {
    const cell = board.tiles.findIndex((t, i) => t.relay && t.owner !== 'blue' && dist(hero.cell!, i) <= 2);
    if (cell >= 0) return { id: 'battle.relay', cell, text: '妖気が立ちのぼる大岩が龍脈です。空いていれば、そのマスを通ると占領できます。守っている妖がいる塔は、その妖を倒して取りましょう。陣地率と、建築に使う陣材の収入が増えます。' };
  }
  return null;
}

/** 画面に出ている方の要素（PC とスマホで同じボタンが2つある）を囲む */
const visibleRect = (sel: string) => () => {
  for (const e of document.querySelectorAll<HTMLElement>(sel)) {
    const r = e.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return r;
  }
  return null;
};
